<app-page-wrapper [title]="'Raporty'" [loading]="false" [error]="null">

  <!-- ===================================================== -->
  <!-- 🔹 HEADER (Widok + Data) -->
  <!-- ===================================================== -->

  <div class="mb-6">

    <div class="flex flex-col gap-4">

      <!-- Row container -->
      <div class="flex flex-col gap-4
                lg:flex-row lg:items-center lg:justify-between">

        <!-- LEFT -->
        <div class="flex flex-col sm:flex-row gap-3 w-full lg:w-auto min-w-0">

          <p-selectbutton
            class="w-full sm:w-auto"
            allowEmpty="false"
            [options]="stateOptions"
            [(ngModel)]="selectedView"
            (onChange)="onViewChange($event.value)"
            optionLabel="label"
            optionValue="value">
          </p-selectbutton>

        </div>

        <!-- RIGHT -->
        <div class="w-full lg:w-auto min-w-0">

          <app-date-range-picker
            class="block w-full lg:w-auto"
            [range]="range()"
            (rangeChange)="onRangeChange($event)"
            (previousWeek)="goToPreviousWeek()"
            (nextWeek)="goToNextWeek()">
          </app-date-range-picker>

        </div>

      </div>

    </div>

  </div>

  <!-- ===================================================== -->
  <!-- 🔹 FILTER PANEL (Toggl style) -->
  <!-- ===================================================== -->

  <div class="mb-6">

    <p-panel
      header="Filtry"
      [toggleable]="true"
      [collapsed]="true"
      class="border-none shadow-sm rounded-xl">

      <form [formGroup]="filterForm" class="pt-2">

        <div class="flex flex-col gap-5">

          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">

            <p-floatlabel class="w-full" variant="on">
              <p-multiselect
                id="clientsLabel"
                [options]="clients()"
                (onChange)="onClientChange($event)"
                formControlName="clients"
                optionLabel="name"
                optionValue="id"
                display="chip"
                styleClass="w-full">
              </p-multiselect>
              <label for="clientsLabel">Klient</label>
            </p-floatlabel>

            <p-floatlabel class="w-full" variant="on">
              <p-multiselect
                id="workItemsLabel"
                [options]="workItems()"
                (onChange)="onWorkItemChange($event)"
                formControlName="workItems"
                optionLabel="name"
                optionValue="id"
                display="chip"
                styleClass="w-full">
              </p-multiselect>
              <label for="workItemsLabel">Projekt</label>
            </p-floatlabel>

            <p-floatlabel class="w-full" variant="on">
              <p-multiselect
                id="statusOptions"
                [options]="statusOptions"
                formControlName="billable"
                optionLabel="label"
                optionValue="value"
                display="chip"
                styleClass="w-full">
              </p-multiselect>
              <label for="statusOptions">Status</label>
            </p-floatlabel>

            @if (isOwner()) {
              <p-floatlabel class="w-full" variant="on">
                <p-multiselect
                  dataKey="id"
                  id="usersLabel"
                  [options]="usersValue()"
                  formControlName="users"
                  optionLabel="fullName"
                  optionValue="id"
                  optionValue="id"
                  optionValue="id"
                  -Xmx14240M                  display="chip"
                  styleClass="w-full">
                  <ng-template let-user pTemplate="item">
                    {{ user.firstName }} {{ user.lastName }}
                  </ng-template>

                  <ng-template let-user pTemplate="selectedItem">
                    {{ user.firstName }} {{ user.lastName }}
                  </ng-template>
                </p-multiselect>
                <label for="usersLabel">Użytkownik</label>
              </p-floatlabel>
            }
          </div>

          <div class="flex justify-end">
            <p-button
              label="Zastosuj filtr"
              icon="pi pi-filter"
              (onClick)="applyFilter()"
              [disabled]="filterForm.invalid || loadingData()">
            </p-button>
          </div>

        </div>

      </form>

    </p-panel>

  </div>

  <!-- ===================================================== -->
  <!-- 🔹 REPORT CONTENT -->
  <!-- ===================================================== -->

  <div>

    <p-card class="rounded-xl shadow-sm">

      <ng-container *ngIf="loadingData()">
        <div class="flex justify-center items-center h-32">
          <p-progressSpinner></p-progressSpinner>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingData()">
        @if (selectedView() == 'summary' && reportData(); as data) {
          <app-summary-report
            [isOwner]="isOwner()"
            [totals]="data.totals!"
            [chartData]="data.chart!"
            [summaryData]="data.reportSummaryTable!"
            [reportRequest]="reportRequestDto()!">
          </app-summary-report>
        }

        @if (selectedView() == 'detailed' && detailedReportData(); as data) {
          <app-detailed-report
            [isOwner]="isOwner()"
            [totals]="data.totals!"
            [tableData]="data.reportDetailedTable!"
            [reportRequest]="reportRequestDto()!">
          </app-detailed-report>
        }
      </ng-container>
    </p-card>
  </div>
</app-page-wrapper>
